import { render, staticRenderFns } from "./BriefPanel.vue?vue&type=template&id=2dbf003c&scoped=true"
import script from "./BriefPanel.vue?vue&type=script&lang=js"
export * from "./BriefPanel.vue?vue&type=script&lang=js"
import style0 from "./BriefPanel.vue?vue&type=style&index=0&id=2dbf003c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dbf003c",
  null
  
)

export default component.exports